/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-nested-ternary */
import React, { FC, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import EasySwipe from 'react-easy-swipe';
import { QRCodeSVG } from 'qrcode.react';
import { useFormikContext } from 'formik';
import { Modal, useBreakpoint } from '@mtsbank/ui-kit';
import { PaymentFormValues } from '@entities/payment';
import { useCyberStore } from '@entities/tsp';
import { useTheme, withTheme } from '@shared/lib';
import { currencySymbols } from '@shared/config';
import { CloseIcon, MultitransferIcon, NspkIcon, SslIcon } from '@shared/assets/icons';
import { OldDivider, Spacer } from '@shared/ui/atoms';
import { Payee } from '@root/api/ump-catalog-manager';
import { paymentSteps } from '../config/paymentSteps';
interface QrModalProps {
  payee: Payee;
  open: boolean;
  handleClose: () => void;
  qrLink: string;
  description: string;
}
const OldSbpQrModalDesktop: FC<QrModalProps> = ({
  payee,
  open,
  handleClose,
  qrLink,
  description
}) => {
  const {
    isPromocodeActivated
  } = useCyberStore();
  const [isClosing, setIsClosing] = useState(true);
  const [swipeDirection, setSwipeDirection] = useState('');
  const {
    isMobile
  } = useBreakpoint();
  const isSteam = payee.features?.tsp_url === 'steam';
  const {
    values
  } = useFormikContext<PaymentFormValues>();
  const theme = useTheme();
  useEffect(() => {
    if (!open) return;
    setIsClosing(false);
  }, [open]);
  const onSwipeStart = () => {
    setSwipeDirection('');
  };
  const onSwipeMove = position => {
    const direction = position.y > 0 ? 'up' : 'down';
    setSwipeDirection(direction);
  };
  const onSwipeEnd = () => {
    if (swipeDirection === 'up') {
      handleCloseModal();
    }
  };
  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      handleClose();
    }, 400);
  };
  return <StyledModal open={open} isClosing={isClosing} onClose={isMobile ? handleCloseModal : handleClose} closeIcon={<CloseIcon />} size="md">
      {/* @ts-ignore */}
      <EasySwipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
        <Modal.Body>
          <PriceWrapper>
            {isPromocodeActivated && isSteam ? values.amountInfo?.base : values.amountInfo?.total || 400}{' '}
            {currencySymbols.RUB}
          </PriceWrapper>
          <DescriptionWrapper>{description}</DescriptionWrapper>
          <Spacer space={32} spacetablet={32} spacemob={32} />
          <WrapperContent>
            <QRCodeWrapper>
              <QRCodeSVG value={qrLink} title="QR Code" size={250} bgColor="#ffffff" fgColor="#000000" level="M" marginSize={4} imageSettings={{
              src: 'https://www.mtsbank.ru/icons/payment/sbp.svg',
              x: undefined,
              y: undefined,
              height: 38,
              width: 38,
              opacity: 1,
              excavate: true
            }} style={{
              borderRadius: '20px'
            }} />
            </QRCodeWrapper>
            <StepsList>
              {paymentSteps.map(({
              step,
              description
            }) => <StepItem key={step}>
                  <StepNumber>{step}</StepNumber>
                  <StepText>{description}</StepText>
                </StepItem>)}
            </StepsList>
          </WrapperContent>
          <Spacer space={8} spacetablet={8} spacemob={8} />
          <Ssl>
            <SslIcon />
            Платёж защищён по протоколу <span style={{
            fontWeight: 500
          }}>SSL</span>
          </Ssl>
          <Spacer space={32} spacetablet={32} spacemob={32} />
          <OldDivider style={{
          backgroundColor: theme.colors.icon.secondary,
          opacity: 0.5
        }} />
          <Spacer space={20} spacetablet={20} spacemob={20} />
          <WrapperFooter>
            <TextWrapper>Сервис предоставлен платёжной системой Мультитрансфер</TextWrapper>
            <IconsWrapper>
              <Nspk>
                <NspkIcon />
              </Nspk>
              <MultiTransfer>
                <MultitransferIcon />
              </MultiTransfer>
            </IconsWrapper>
          </WrapperFooter>
        </Modal.Body>
      </EasySwipe>
    </StyledModal>;
};
export default OldSbpQrModalDesktop;
interface StyledModalProps {
  isClosing: boolean;
  open: boolean;
}
const _exp = /*#__PURE__*/() => Modal;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.secondary;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp8 = /*#__PURE__*/() => ({
  isClosing
}) => isClosing ? 'translateY(100%)' : 'translateY(0)';
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.tertiary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const StyledModal = withTheme(/*#__PURE__*/styled(_exp())({
  name: "StyledModal",
  class: "sbq29jr",
  propsAsIs: true,
  vars: {
    "sbq29jr-0": [_exp2()],
    "sbq29jr-1": [_exp3()],
    "sbq29jr-2": [_exp7(), "px"],
    "sbq29jr-3": [_exp5()],
    "sbq29jr-4": [_exp6(), "px"],
    "sbq29jr-5": [_exp8()],
    "sbq29jr-6": [_exp9()],
    "sbq29jr-7": [_exp0()]
  }
}));
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp13 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const PriceWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "PriceWrapper",
  class: "p1khvm5i",
  propsAsIs: false,
  vars: {
    "p1khvm5i-0": [_exp1()],
    "p1khvm5i-1": [_exp10()],
    "p1khvm5i-2": [_exp11(), "px"],
    "p1khvm5i-3": [_exp12()],
    "p1khvm5i-4": [_exp13(), "px"]
  }
}));
const _exp14 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.secondary;
const _exp15 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp16 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp17 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp18 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const DescriptionWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "DescriptionWrapper",
  class: "da3gate",
  propsAsIs: false,
  vars: {
    "da3gate-0": [_exp14()],
    "da3gate-1": [_exp15()],
    "da3gate-2": [_exp16(), "px"],
    "da3gate-3": [_exp17()],
    "da3gate-4": [_exp18(), "px"]
  }
}));
const QRCodeWrapper = /*#__PURE__*/styled('div')({
  name: "QRCodeWrapper",
  class: "qtgkgbb",
  propsAsIs: false
});
const WrapperFooter = /*#__PURE__*/styled('div')({
  name: "WrapperFooter",
  class: "w1tvei8o",
  propsAsIs: false
});
const _exp19 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp20 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp21 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp22 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp23 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const Ssl = withTheme(/*#__PURE__*/styled('div')({
  name: "Ssl",
  class: "sg00vf9",
  propsAsIs: false,
  vars: {
    "sg00vf9-0": [_exp19()],
    "sg00vf9-1": [_exp20()],
    "sg00vf9-2": [_exp21(), "px"],
    "sg00vf9-3": [_exp22()],
    "sg00vf9-4": [_exp23(), "px"]
  }
}));
const StepsList = /*#__PURE__*/styled('div')({
  name: "StepsList",
  class: "s18bmv4w",
  propsAsIs: false
});
const StepItem = /*#__PURE__*/styled('div')({
  name: "StepItem",
  class: "sr105sk",
  propsAsIs: false
});
const _exp24 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp25 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp26 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp27 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const StepText = withTheme(/*#__PURE__*/styled('div')({
  name: "StepText",
  class: "sg5rb0o",
  propsAsIs: false,
  vars: {
    "sg5rb0o-0": [_exp24()],
    "sg5rb0o-1": [_exp25()],
    "sg5rb0o-2": [_exp26(), "px"],
    "sg5rb0o-3": [_exp27(), "px"]
  }
}));
const _exp28 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const _exp29 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.white;
const _exp30 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp31 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp32 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const StepNumber = withTheme(/*#__PURE__*/styled('div')({
  name: "StepNumber",
  class: "s1n7oopm",
  propsAsIs: false,
  vars: {
    "s1n7oopm-0": [_exp28()],
    "s1n7oopm-1": [_exp29()],
    "s1n7oopm-2": [_exp30()],
    "s1n7oopm-3": [_exp31(), "px"],
    "s1n7oopm-4": [_exp32()]
  }
}));
const WrapperContent = /*#__PURE__*/styled('div')({
  name: "WrapperContent",
  class: "w1bju5io",
  propsAsIs: false
});
const _exp33 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp34 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp35 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp36 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const _exp37 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.secondary;
const TextWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "tdhlk",
  propsAsIs: false,
  vars: {
    "tdhlk-0": [_exp33()],
    "tdhlk-1": [_exp34()],
    "tdhlk-2": [_exp35(), "px"],
    "tdhlk-3": [_exp36(), "px"],
    "tdhlk-4": [_exp37()]
  }
}));
const IconsWrapper = /*#__PURE__*/styled('div')({
  name: "IconsWrapper",
  class: "i1tqz2od",
  propsAsIs: false
});
const _exp38 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.secondary;
const Nspk = withTheme(/*#__PURE__*/styled('div')({
  name: "Nspk",
  class: "ni7g7pi",
  propsAsIs: false,
  vars: {
    "ni7g7pi-0": [_exp38()]
  }
}));
const _exp39 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.secondary;
const MultiTransfer = withTheme(/*#__PURE__*/styled('div')({
  name: "MultiTransfer",
  class: "m1irxt1h",
  propsAsIs: false,
  vars: {
    "m1irxt1h-0": [_exp39()]
  }
}));

require("./OldSbpQrModalDesktop.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OldSbpQrModalDesktop.tsx");